import React, { useEffect, useState } from 'react';
import ProcessCard from '../components/ProcessCard';
import CandidatoModal from '../components/CandidatoModal';
import CandidatoDetalle from '../components/CandidatoDetalle';
import ProcesoModal from '../components/ProcesoModal';
import { Plus, Search, FolderPlus } from 'lucide-react';
import { getProcesos } from '../api'; 

const ProcesosActivos = () => {
  const [procesos, setProcesos] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProcesoModalOpen, setIsProcesoModalOpen] = useState(false);
  const [selectedCandidato, setSelectedCandidato] = useState(null);

  const fetchData = async () => {
    try {
      const res = await getProcesos();
      setProcesos(res.data);
    } catch (err) {
      console.error("Error cargando datos:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="p-8 w-full">
      <div className="max-w-7xl mx-auto mb-8 flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-800 uppercase tracking-wider">Procesos de búsqueda activos</h1>
        <div className="flex gap-4">
          <button 
            onClick={() => setIsProcesoModalOpen(true)}
            className="bg-white text-emeral-green border border-emeral-green px-4 py-2 rounded flex items-center gap-2 font-bold text-sm hover:bg-green-50 transition"
          >
            <FolderPlus size={18} /> AGREGAR PROCESO
          </button>
          <button 
            onClick={() => setIsModalOpen(true)}
            className="bg-emeral-green text-white px-4 py-2 rounded flex items-center gap-2 font-bold text-sm hover:bg-opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={procesos.length === 0}
          >
            <Plus size={18} /> AGREGAR CANDIDATO
          </button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto bg-white p-4 rounded-lg shadow-sm mb-6 flex gap-4 items-center border border-gray-200">
        <div className="flex-1 flex items-center border rounded px-3 py-1 text-gray-400 focus-within:border-emeral-green transition">
          <Search size={16} />
          <input type="text" placeholder="Filtrar por cargo o código..." className="ml-2 outline-none w-full text-sm text-gray-700" />
        </div>
        <button className="bg-emeral-green p-2 rounded text-white hover:bg-opacity-90 transition"><Search size={18}/></button>
      </div>

      <div className="max-w-7xl mx-auto mb-4 border-b border-gray-300 flex gap-8">
        <button className="pb-2 border-b-2 border-emeral-green text-emeral-green font-bold text-sm flex items-center gap-2">
          ACTIVOS <span className="bg-green-500 text-white px-2 rounded-full text-xs">{procesos.length}</span>
        </button>
        <button className="pb-2 text-gray-400 font-bold text-sm flex items-center gap-2 hover:text-gray-600 transition">
          SUSPENDIDOS <span className="bg-gray-400 text-white px-2 rounded-full text-xs">0</span>
        </button>
        <button className="pb-2 text-gray-400 font-bold text-sm flex items-center gap-2 hover:text-gray-600 transition">
          CERRADOS <span className="bg-gray-400 text-white px-2 rounded-full text-xs">0</span>
        </button>
      </div>

      <div className="max-w-7xl mx-auto pb-12">
        {procesos.length === 0 ? (
          <div className="bg-white p-12 text-center text-gray-500 rounded-lg shadow-sm border border-dashed border-gray-300 flex flex-col items-center">
            <FolderPlus size={48} className="text-gray-300 mb-4" />
            <h3 className="text-lg font-bold text-gray-700">Sin registros</h3>
            <p className="text-sm">No hay procesos activos. Comienza creando un nuevo proceso.</p>
          </div>
        ) : (
          procesos.map((proc) => (
            <ProcessCard 
              key={proc.id} 
              {...proc} 
              onCandidatoClick={setSelectedCandidato} 
            />
          ))
        )}
      </div>

      <CandidatoModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        onRefresh={fetchData}
        procesos={procesos}
      />
      
      <ProcesoModal 
        isOpen={isProcesoModalOpen}
        onClose={() => setIsProcesoModalOpen(false)}
        onRefresh={fetchData}
      />

      <CandidatoDetalle 
        candidato={selectedCandidato}
        isOpen={!!selectedCandidato}
        onClose={() => setSelectedCandidato(null)}
      />
    </div>
  );
};

export default ProcesosActivos;
